import React, { useState } from 'react';
import { Star, Quote } from 'lucide-react';
import { mockData } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const Testimonials = () => {
  const [expandedReview, setExpandedReview] = useState(null);

  const toggleReview = (id) => {
    setExpandedReview(expandedReview === id ? null : id);
  };

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <section id="atsauksmes" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-sky-100 text-sky-700 rounded-full text-sm font-medium mb-4">
            <Star className="w-4 h-4" />
            <span>Atsauksmes</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Ko saka mūsu klienti
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Mēs lepojamies ar saviem rezultātiem un klientu apmierinātību
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6 items-stretch">
          {mockData.testimonials.map((testimonial) => {
            const isLongText = testimonial.text.length > 120;
            const isExpanded = expandedReview === testimonial.id;
            const displayText = isLongText && !isExpanded 
              ? truncateText(testimonial.text, 120)
              : testimonial.text;

            return (
              <Card 
                key={testimonial.id}
                className="border-2 border-gray-100 hover:border-sky-200 hover:shadow-lg transition-all duration-300 relative flex flex-col"
              >
                <CardContent className="p-5 md:p-6 flex flex-col h-full">
                  {/* Quote icon */}
                  <div className="absolute top-4 right-4 opacity-10">
                    <Quote className="w-12 h-12 text-sky-500" />
                  </div>

                  {/* Rating */}
                  <div className="flex items-center space-x-2 mb-3">
                    <div className="flex space-x-1">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                      ))}
                    </div>
                    {testimonial.timeAgo && (
                      <span className="text-xs text-gray-500">{testimonial.timeAgo}</span>
                    )}
                  </div>

                  {/* Text */}
                  <p className="text-sm md:text-base text-gray-700 mb-3 leading-relaxed relative z-10 flex-1">
                    {displayText}
                  </p>

                  {/* Read More Button */}
                  {isLongText && (
                    <button
                      onClick={() => toggleReview(testimonial.id)}
                      className="text-sky-500 hover:text-sky-600 text-sm font-medium mb-3 text-left"
                    >
                      {isExpanded ? 'Lasīt mazāk' : 'Lasīt vairāk'}
                    </button>
                  )}

                  {/* Author */}
                  <div className="border-t border-gray-100 pt-3 mt-auto">
                    <p className="font-semibold text-gray-900 text-sm">{testimonial.name}</p>
                    <p className="text-xs text-gray-600">{testimonial.role}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-12 md:mt-16 text-center bg-gradient-to-br from-sky-50 to-blue-50 rounded-2xl p-10 md:p-12">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Kļūsti par mūsu nākamo apmierināto klientu!
          </h3>
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Neatliec savu komfortu uz nākotni - sazinies ar mums
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('kontakti');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center px-8 py-4 bg-sky-500 hover:bg-sky-600 text-white font-semibold rounded-lg transition-colors text-lg shadow-lg hover:shadow-xl"
          >
            Pieteikt tīrīšanu tagad
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
